import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UsersState } from './users.state';

export const selectUsersState = createFeatureSelector<UsersState>('adminUsers');

export const selectAllUsers = createSelector(
  selectUsersState,
  (state) => state.users,
);

export const selectUsersLoading = createSelector(
  selectUsersState,
  (state) => state.loading,
);

export const selectUsersError = createSelector(
  selectUsersState,
  (state) => state.error,
);

export const selectUsersPagination = createSelector(
  selectUsersState,
  (state) => state.pagination,
);

export const selectSelectedUser = createSelector(
  selectUsersState,
  (state) => state.selectedUser,
);

export const selectUserById = (id: string) => createSelector(
  selectAllUsers,
  (users) => users.find(user => user.id === id),
);
